import { NgModule } from '@angular/core';
import { SliderPickerComponent } from './slider-picker.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UtilsService } from '@library/utils/services/utils.service';
import { AtomsModule } from '@library/ui/atoms/atoms.module'

@NgModule({
  declarations: [SliderPickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    AtomsModule,
  ],
  exports: [SliderPickerComponent],
  providers: [
    UtilsService,
  ]
})
export class SliderPickerModule { }
